# /**** Based on Appcues Notification Center sample code **************
#  *
#  *    2017-11-21, pete gamache, pete@appcues.com
#  *
#  *    API Documentation: https://api.appcues.com/v1-docs.html#rel-nc
#  *
#  *********************************************************************/

Promise = require 'bluebird'
Events = require('backbone').Events
AjaxPromise = require 'network/ajax-promise'
_ = require 'underscore'
xtend = require 'xtend'
Util = require 'lib/util'

_appcuesRequest = (path, opts) ->
  return AjaxPromise xtend({ url: "https://fast-nc.appcues.com#{path}" }, opts)

AppcuesNc =
  getItems: (userId) ->
    if userId == @userId && @dateLastRefreshed > Util.dateBefore({ minutes: 60 })
      return @items
    if userId != @userId
      @items = []
      @userId = userId
    @_downloadItems(window.appcuesAccountId, userId)
    return @items

  _downloadItems: (accountId, userId) ->
    _appcuesRequest "/v1/accounts/#{accountId}/users/#{userId}/nc?include=announcement"
    .bind @
    .then (ncResponse) =>
      if typeof ncResponse != 'object' then ncResponse = JSON.parse(ncResponse)

      @items =
        ncResponse['_embedded']['appcues:nc_item'].filter (item) ->
          item.id &&
          item.content?.attributes?.content?.title &&
          item.content?.attributes?.content?.body?.bodyHtml
        .map (item) -> new AppcuesItem(item)
      @dateLastRefreshed = new Date()
      @_itemsUpdated()

  _itemsUpdated: ->
      @trigger 'appcuesUpdate', @items

class AppcuesItem
  constructor: (item) ->
    {
      id: @id,
      seen: @seen,
      _links: {
        'appcues:nc_item_mark_seen': { href: @markSeenUrl },
        'appcues:nc_item_clear_seen': { href: @clearSeenUrl }
      },
      content: {
        attributes: {
          content: { title: @title, img: @img, links: @links, body: { bodyHtml: @bodyHtml } } } }
    } = item

  markSeen: ->
    @seen = true
    AppcuesNc._itemsUpdated()
    _appcuesRequest @markSeenUrl, { method: 'POST' }

  clearSeen: ->
    @seen = false
    AppcuesNc._itemsUpdated()
    _appcuesRequest @clearSeenUrl, { method: 'POST' }

_.extend AppcuesNc, Events

module.exports = AppcuesNc



// WEBPACK FOOTER //
// ./app/scripts/network/appcues-nc.coffee